import Swiper, {Pagination} from 'swiper';

export const SliderSkills = {
	init: () => {
		const isMobile = window.matchMedia('(min-width: 0px) and (max-width: 1024px)').matches;
		
		if(!isMobile) return

		const swiper = new Swiper('.swiper-skills', {
			modules: [Pagination],

			allowTouchMove: true,

			direction: 'horizontal',
			loop: false,
			slidesPerView: 1.15,
			spaceBetween: 24,

			pagination: {
				el: '.swiper-pagination',
				type: 'bullets',
				clickable: true
			},

			scrollbar: {
				el: '.swiper-scrollbar',
			},
		});

	}
}